import { useState, createContext, useContext, useMemo } from "react";

const UserProfilePictureContext = createContext(null);

export const UserProfilePictureProvider = ({ children }) => {
  const [profileImage, setProfileImage] = useState(null);
  const [isFetching, setIsFetching] = useState(true);

  const contextValue = useMemo(() => ({
    setUserProfilePicture: (file) => setProfileImage(file),
    profileImage,
    setIsFetchingState: (value) => setIsFetching(value),
    isFetching,
  }), [profileImage, isFetching]);

  return (
    <UserProfilePictureContext.Provider value={contextValue}>
      {children}
    </UserProfilePictureContext.Provider>
  );
};

export const useProfilePicture = () => {
  return useContext(UserProfilePictureContext);
};